import Ionicons from 'react-native-vector-icons/Ionicons';
import styled from 'styled-components/native';

import dynamicSize from '@webtrader/core/dynamic-size';

import Text from '@/components/Text';
import TouchableOpacity from '@/components/Touch/Opacity';

export const StyledIonicons = styled(Ionicons)`
  color: ${({ theme }) => theme.colors.text[1]};
`;

export const StyledFormField = styled.View<{ isPaddingBottom?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: ${({ theme, isPaddingBottom }) =>
    `${dynamicSize.convertSize(8)}px ${theme.sizes.mobile.basePaddingEnd}px ${
      isPaddingBottom ? dynamicSize.convertSize(8) : 0
    }px ${theme.sizes.mobile.basePaddingStart}px `};

  background-color: ${({ theme }) => theme.colors.background[0]};
`;

export const StyledFormTitleContainer = styled.View`
  flex: 1;
  flex-direction: row;
  align-items: center;
  padding-end: ${dynamicSize.convertSize(6)}px;
`;

export const StyledFormTitle = styled(Text)`
  padding: ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;

  color: ${({ theme }) => theme.colors.text[0]};
  font-size: ${dynamicSize.convertSize(15)}px;
`;

export const StyledValidationContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const FormValidation = styled(Text)`
  margin: 4px;

  font-size: ${dynamicSize.convertSize(12)}px;
  font-weight: 400;

  color: ${({ theme }) => theme.colors.error[0]};
`;

export const StyledActionSheet = styled(TouchableOpacity)``;

export const StyledDropdownSelectorContainer = styled(TouchableOpacity)<{ selected?: boolean }>`
  height: ${dynamicSize.convertSize(40)}px;
  padding: 0px ${dynamicSize.convertSize(12)}px;

  align-items: center;
  flex-direction: row;
  justify-content: space-between;

  background-color: ${({ theme, selected }) => theme.colors.background[selected ? 1 : 0]};
`;

export const StyledDropdownSelectorText = styled(Text)`
  font-size: ${dynamicSize.convertSize(15)}px;
`;

export const StyledDropdownSelectorIcon = styled.View`
  font-size: ${dynamicSize.convertSize(15)}px;
`;

export const StyledInputWrapper = styled.View`
  flex: 1;
`;
